<div class="left">
  <div class="header-container">
    <a class="logo" href="#">
      <h2 class="text-primary">
        <img src="../../../../assets/images/24.png" alt="MP Fenix logo">
      </h2>
    </a>
  </div>
</div>

<div class="header-container" *ngIf="isMobile">
  <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
    <nb-icon icon="menu-2-outline"></nb-icon>
  </a>
</div>
